import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 213621FE-E003-4B40-9385-B9BCE19DB035
 * name volume-low
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-low.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const VolumeLowIcon = createSvgIcon(<><path d="M7,9V15H11L16,20V4L11,9H7Z" /></>, 'VolumeLowIcon');
export default VolumeLowIcon